import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "loaderGenerateTaskArea" }

import { useStore } from "vuex";
import { computed, watchEffect, ref } from "vue";
import { TaskActions, TaskGetters } from "@/store/modules/task";
import { Task, TaskStatusEnum, TaskTypeEnum } from "@/store/modules/task/types";
import { taskAPI, TaskListParam } from "@/api/task";
import { baseUrl } from "@/requests";
import { ElMessage } from 'element-plus';
import LoaderGenerateTaskDetails from "@/components/loaderGenerator/loaderGenerateTaskDetails.vue";


import { defineComponent } from "vue";

const __default__ = defineComponent({
    name: "LoaderGenerateTask"
})


export default /*#__PURE__*/_defineComponent({
  ...__default__,
  setup(__props) {

const store = useStore();

const taskList = computed(() => {
    return store.getters[`task/${TaskGetters.getTaskList}`];
});

const isLoading = computed(() => {
    return store.getters[`task/${TaskGetters.getLoading}`];
});

const selectedProj = computed(() => {
    return store.getters[`task/${TaskGetters.getSelectedProj}`];
});

const createStatus = computed(() => {
    return store.getters[`task/${TaskGetters.getCreateStatus}`];
})

const pwdDialog = ref<boolean>(false)
const DownLinkDialog = ref<boolean>(false)
const DownLink = ref<string>("")
const selectedTask = ref<Task>()

const timeFormatter = (row: Task, column: any) => {
    const date = (new Date(new Date(new Date(row.updateAt).toUTCString()).getTime() + 8 * 60 * 60 * 1000)).toISOString()
    return date.substring(0, 10) + "  " + date.substring(11, 19)
}
const handleDownload = async (task: Task) => {
    try {
        selectedTask.value = task
        if (task.pwd === "") {
            pwdDialog.value = false
        } else {
            pwdDialog.value = true
        }
        const url = await taskAPI.getSparrowPathByTaskId(task.id);
        window.open(baseUrl + url)
    } catch (err) {
        console.error(err);
    }
}

const handleGenDownloadLinkForOut = async (task: Task) => {
    try {
        selectedTask.value = task
        const url = await taskAPI.GenDownloadLinkForOut(task.id)
        DownLink.value = window.location.origin + baseUrl + url
        DownLinkDialog.value = true

    } catch (err) {
        console.error(err);
    }
}

const copyText = (text: string): void => {
    try {
        let oInput = document.createElement('input');
        oInput.value = text;
        document.body.appendChild(oInput);
        oInput.select();
        document.execCommand("Copy");
        oInput.style.display = 'none';
        ElMessage({
            message: '复制成功',
            type: 'success',
        })
    } catch (err) {
        console.log(err)
    }
}

const refreshTaskList = async () => {
    if (selectedProj.value !== "") {
        const taskListParam: TaskListParam = {
            projId: selectedProj.value,
            typeList: JSON.stringify([TaskTypeEnum.SparrowGen]),
        };
        store.dispatch(`task/${TaskActions.asyncGetOwnTaskListInProjByTypes}`, taskListParam);
    }
}

const isLoaderGenerateTaskExpired = (updateTime: string): boolean => {
    let updateTimeStamp = new Date(new Date(updateTime).toUTCString()).getTime()
    let nowTimeStamp = new Date(new Date().toUTCString()).getTime()
    return nowTimeStamp > updateTimeStamp + 30 * 60 * 1000
}

watchEffect(() => {
    if (selectedProj.value !== "") {
        const taskListParam: TaskListParam = {
            projId: selectedProj.value,
            typeList: JSON.stringify([TaskTypeEnum.SparrowGen]),
        };
        store.dispatch(`task/${TaskActions.asyncGetOwnTaskListInProjByTypes}`, taskListParam);
    }
});


return (_ctx: any,_cache: any) => {
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_popover = _resolveComponent("el-popover")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_tag = _resolveComponent("el-tag")!
  const _component_el_table = _resolveComponent("el-table")!
  const _component_el_dialog = _resolveComponent("el-dialog")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_el_button, {
        class: "refresh",
        type: "primary",
        onClick: refreshTaskList
      }, {
        default: _withCtx(() => [
          _createTextVNode("刷新")
        ]),
        _: 1
      }),
      _withDirectives((_openBlock(), _createBlock(_component_el_table, {
        data: _unref(taskList),
        stripe: "",
        style: {"overflow":"auto"}
      }, {
        default: _withCtx(() => [
          _createVNode(_component_el_table_column, {
            align: "center",
            prop: "id",
            label: "任务Id"
          }, {
            default: _withCtx((scope) => [
              _createVNode(_component_el_popover, {
                placement: "top-start",
                title: "编译参数",
                width: 400,
                trigger: "hover"
              }, {
                reference: _withCtx(() => [
                  _createElementVNode("p", null, _toDisplayString(scope.row.id), 1)
                ]),
                default: _withCtx(() => [
                  _createVNode(LoaderGenerateTaskDetails, {
                    payloadStr: scope.row.payload
                  }, null, 8, ["payloadStr"])
                ]),
                _: 2
              }, 1024)
            ]),
            _: 1
          }),
          _createVNode(_component_el_table_column, {
            align: "center",
            prop: "status",
            label: "状态"
          }, {
            default: _withCtx((scope) => [
              (scope.row.status === _unref(TaskStatusEnum).StatusIdle)
                ? (_openBlock(), _createBlock(_component_el_tag, {
                    key: 0,
                    type: "info"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode("未知")
                    ]),
                    _: 1
                  }))
                : (scope.row.status === _unref(TaskStatusEnum).StatusProcessing)
                  ? (_openBlock(), _createBlock(_component_el_tag, { key: 1 }, {
                      default: _withCtx(() => [
                        _createTextVNode("处理中")
                      ]),
                      _: 1
                    }))
                  : (scope.row.status === _unref(TaskStatusEnum).StatusDownloading)
                    ? (_openBlock(), _createBlock(_component_el_tag, { key: 2 }, {
                        default: _withCtx(() => [
                          _createTextVNode("获取中")
                        ]),
                        _: 1
                      }))
                    : (scope.row.status === _unref(TaskStatusEnum).StatusFinished)
                      ? (_openBlock(), _createBlock(_component_el_tag, {
                          key: 3,
                          type: "success"
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode("成功")
                          ]),
                          _: 1
                        }))
                      : (scope.row.status === _unref(TaskStatusEnum).StatusFailed)
                        ? (_openBlock(), _createBlock(_component_el_tag, {
                            key: 4,
                            type: "danger"
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode("错误")
                            ]),
                            _: 1
                          }))
                        : _createCommentVNode("", true),
              (isLoaderGenerateTaskExpired(scope.row.updateAt))
                ? (_openBlock(), _createBlock(_component_el_tag, {
                    key: 5,
                    type: "warning"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode("过期")
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true)
            ]),
            _: 1
          }),
          _createVNode(_component_el_table_column, {
            align: "center",
            prop: "updateAt",
            label: "更新时间",
            formatter: timeFormatter
          }),
          _createVNode(_component_el_table_column, {
            align: "center",
            label: "操作"
          }, {
            default: _withCtx((scope) => [
              _createVNode(_component_el_button, {
                disabled: scope.row.status !== _unref(TaskStatusEnum).StatusFinished,
                type: "primary",
                onClick: ($event: any) => (handleDownload(scope.row))
              }, {
                default: _withCtx(() => [
                  _createTextVNode("下载")
                ]),
                _: 2
              }, 1032, ["disabled", "onClick"]),
              _createVNode(_component_el_button, {
                disabled: scope.row.status !== _unref(TaskStatusEnum).StatusFinished,
                type: "primary",
                onClick: ($event: any) => (handleGenDownloadLinkForOut(scope.row))
              }, {
                default: _withCtx(() => [
                  _createTextVNode("生成链接")
                ]),
                _: 2
              }, 1032, ["disabled", "onClick"])
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["data"])), [
        [_directive_loading, _unref(isLoading)]
      ])
    ]),
    _createVNode(_component_el_dialog, {
      modelValue: pwdDialog.value,
      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((pwdDialog).value = $event)),
      title: "解压密码",
      width: "50%"
    }, {
      default: _withCtx(() => [
        _createTextVNode(" 密码为：" + _toDisplayString(selectedTask.value === undefined ? "" : selectedTask.value.pwd) + " ", 1),
        _createVNode(_component_el_button, {
          type: "primary",
          link: "",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (copyText(selectedTask.value === undefined ? '' : selectedTask.value.pwd)))
        }, {
          default: _withCtx(() => [
            _createTextVNode("复制")
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_component_el_dialog, {
      modelValue: DownLinkDialog.value,
      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((DownLinkDialog).value = $event)),
      title: "下载链接",
      width: "50%"
    }, {
      default: _withCtx(() => [
        _createTextVNode(" 链接：" + _toDisplayString(DownLink.value) + " ", 1),
        _createVNode(_component_el_button, {
          type: "primary",
          link: "",
          onClick: _cache[2] || (_cache[2] = ($event: any) => (copyText(DownLink.value)))
        }, {
          default: _withCtx(() => [
            _createTextVNode("复制")
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["modelValue"])
  ], 64))
}
}

})